// extracted by mini-css-extract-plugin
export var assigneeBadge = "_i5-0";
export var assigneeDetails = "_i5-1";
export var assigneeInfo = "_i5-2";
export var dropdownContainer = "_i5-4";
export var dropdownImage = "_i5-5";
export var editAssigneeInfo = "_i5-3";
export var editAssigneeModalContainer = "_i5-6";
export var hidden = "_i5-8";
export var input = "_i5-7";